import { Button, Heading, Separator, Text } from "@nju/ui";

interface IAppointmentDateChangeSuccessProps {
  onSubmit: () => void;
}

export function AppointmentDateChangeSuccess({
  onSubmit,
}: IAppointmentDateChangeSuccessProps) {
  return (
    <div className="text-center">
      <Heading
        className="flex justify-center font-bold mb-3 from-tablet:mb-6"
        font="ttfirs"
        tone="neutral"
        variant="h2"
      >
        zmiany zostały zapisane
      </Heading>
      <Separator size="s" tone="invisible" />
      <div className="flex justify-center">
        <img alt="Informacje o cookies" src="/images/calendar-success.svg" />
      </div>
      <Separator size="s" tone="invisible" />
      <Text
        className="flex justify-center"
        size={{
          "@fromDesktop": "l",
        }}
      >
        Termin instalacji usługi nju światłowód został zmieniony
      </Text>
      <Separator size="s" tone="invisible" />
      <div className="flex justify-center">
        <Button onPress={onSubmit}>ok</Button>
      </div>
    </div>
  );
}
